import { ActionDeleteIcon, EditIcon, TableActionIcon } from '@checkit/react-components/build/components/Icons';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { Location } from 'history';
import * as React from 'react';
import { ReactNode, useState } from 'react';
import { useIntl } from 'react-intl';
import AlertDialog from '../../components/alert/AlertDialog';
import MaterialUiLink from '../../components/MaterialUiLink';
import { messages } from '../list/CheckpointList.translations';

type ActionLink = Pick<Location, 'state' | 'pathname'>;

interface ActionLinks {
  delete: ActionLink;
  update: ActionLink;
}

interface ActionTexts {
  updateText: string;
  deleteText: string;
  ariaLabel: string;
}

interface CheckpointActionsProps {
  displayName: string;
  links: ActionLinks;
  texts: ActionTexts;
  onDelete(): void;
}

export function CheckpointActions({
  displayName,
  links,
  texts,
  onDelete
}: CheckpointActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const { formatMessage } = useIntl();

  const deleteModalContent = (
    <>
      {/* The default is <p>, but inside a modal we get ne*/}
      <Typography component="span">
        {formatMessage(
          messages['checkpoint.list.actions.delete.areYouSure'],
          {
            b: (...chunks: ReactNode[]) => <b>{chunks}</b>,
            displayName
          }
        )}
      </Typography>
      <br />
      <br />
      <Typography component="span">
        {formatMessage(
          messages['checkpoint.list.actions.delete.description'],
          {
            i: (...chunks: ReactNode[]) => <i>{chunks}</i>
          }
        )}
      </Typography>
    </>
  );
  function handleOpenMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleCloseMenu() {
    setAnchorEl(null);
  }

  function onAcceptDelete() {
    onDelete();
    setDeleteModalOpen(false);
  }

  function onCancelDelete() {
    setDeleteModalOpen(false);
  }

  function handleDelete() {
    setDeleteModalOpen(true);
    handleCloseMenu();
  }

  return (
    <>
      <IconButton
        aria-label={texts.ariaLabel}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
      >
        <TableActionIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleCloseMenu} component={MaterialUiLink} to={links.update}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          {texts.updateText}
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemIcon>
            <ActionDeleteIcon />
          </ListItemIcon>
          {texts.deleteText}
        </MenuItem>
      </Menu>
      <AlertDialog
        onAccept={onAcceptDelete}
        onCancel={onCancelDelete}
        open={deleteModalOpen}
        text={deleteModalContent}
        title={formatMessage(
          messages['checkpoint.list.actions.delete.modalTitle']
        )}
      />
    </>
  );

}
